import { signOut } from '@/auth/cognito.service';
import { SettingFilled } from '@ant-design/icons';
import { FormattedMsg } from '@components/i18n/formattedMsg';
import { changeLanguage } from '@components/i18n/i18n';
import LanguageMenu from '@components/i18n/LanguageMenu';
import DashHeader from '@components/styles/Header';
import { Layout, Menu } from 'antd';
import Link from 'next/link';
import Router from 'next/router';
import { connect } from 'react-redux';

const { SubMenu } = Menu;
const { Header } = Layout;

async function onSettingClick({ domEvent }) {
    domEvent.preventDefault();
    await signOut(() => {
        Router.push('/');
        window.location.reload();
    });
}

const SettingMenu = () => (
    <>
        <Menu
            mode='horizontal'
            style={{ background: 'transparent' }}
            onClick={(e) => onSettingClick(e)}
            data-test-id='setting-menu'
        >
            <SubMenu
                style={{ background: 'transparent' }}
                title={
                    <SettingFilled
                        style={{
                            fontSize: 17,
                            color: 'white',
                            marginRight: 0,
                        }}
                    />
                }
            >
                <Menu.Item
                    data-test-id='settings.menu.logout'
                    key={'settings.menu.logout'}
                    value='settings.menu.logout'
                >
                    <FormattedMsg id='settings.menu.logout' />
                </Menu.Item>
            </SubMenu>
        </Menu>
    </>
);

const MainHeader = (props) => {
    function onLanguageChange(domEvent, key) {
        domEvent.preventDefault();
        changeLanguage(key, props.dispatch);
    }

    return (
        <DashHeader>
            <Header>
                <Link href='/'>
                    <a className='brand'>
                        <img src={'https://static.qupital.com/funder/company_logo.svg'} />
                    </a>
                </Link>

                <span className='mr-auto' />

                <LanguageMenu onLanguageChange={onLanguageChange} />
                <SettingMenu />
            </Header>
        </DashHeader>
    );
};

export default connect()(MainHeader);
